(function () {
  'use strict';

  class FormMacroCtrl {
    constructor(safetyService, ServiceVfiltro, FactoryVfiltro, Authenticator, blockUI, $stateParams, $state) {
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.stateParams = $stateParams;
      this.blockUI = blockUI;
      this.state = $state;

      this.macroGroupUUID = this.stateParams.macroGroupUUID;
      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([])
      );
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './MacroGroupFormPageRoute',
          componentId = 'safety-macro-group-form',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goBackToList(tabIndex) {
      this.state.go('root.macro', {
        tabIndex: tabIndex
      });
    }

    getReactProps() {
      return {
        user: this.user,
        macroGroupUUID: this.macroGroupUUID,
        goBackToList: (tabIndex) => this.goBackToList(tabIndex)
      };
    }
  }

  angular
    .module('cadastros.macro')
    .controller('FormMacroCtrl', FormMacroCtrl);
}());
